import React, { forwardRef, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';
import 'react-toastify/dist/ReactToastify.css';

const ContactForm = forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    name: '',
    email: '',
    phone: '',
    message: ''
  };

  const handleSubmit = (values, { resetForm }) => {
    setIsLoading(true);

    emailjs
      .send(
        // "service_c6160b6",        
        // "template_qd5ha8u",        
        values,
        // "L0KBmrMAfZc36Qh-y"     
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success("Thank you for your inquiry! Our admissions team will contact you soon");
          resetForm();
        },
        (error) => {
          console.error(error.text);
          toast.error("Oops! Something went wrong. Please try again later.");
        }
      )
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="max-w-5xl mx-auto py-16 p-4" ref={ref}>
      <p style={{ letterSpacing: "0.15rem", lineHeight: "1.25rem" }}
        className="uppercase text-sm md:text-base text-gray-600 mb-4 font-bold">
        Get In Touch With Us
      </p>
      <h2 className="text-center text-6xl font-bold mb-6">Contact Us for Course Information and Enrollment</h2>
      <p className="text-center text-lg mb-4">
  Have questions about our courses, admissions, or training programs? We’d love to help.
</p>
<p className="text-center text-lg mb-8">
  Fill out the form below and our team will get back to you shortly.
</p>

      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {() => (
          <Form id="contactUs" className="">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-start my-4">
              <div>
                <label className="block mb-1 font-semibold">Name<span className="text-red-500"> *</span></label>
                <Field type="text" name="name" required className="w-full border px-4 py-2 rounded bg-gray-100" />
              </div>
              <div>
                <label className="block mb-1 font-semibold">Email<span className="text-red-500"> *</span></label>
                <Field type="email" name="email" required className="w-full border px-4 py-2 rounded bg-gray-100" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-start">
              <div>
                <label className="block mb-1 font-semibold">Phone</label>
                <Field type="text" name="phone" className="w-full border px-4 py-2 rounded bg-gray-100" />
              </div>
              <div>
               
              </div>
            </div>

            <div className='my-4'>
              <label className="block mb-1 font-semibold text-start">Leave a message</label>
              <Field as="textarea" name="message" rows="6" className="w-full border px-4 py-2 rounded bg-gray-100" />
            </div>

            <div className="mt-10 flex justify-center">
              <button
                type="submit"
                disabled={isLoading}
                className={`bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-bold py-3 px-8 rounded-full flex items-center justify-center gap-2 ${isLoading ? 'opacity-60 cursor-not-allowed' : ''}`}
              >
                {isLoading ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                    Submitting...
                  </>
                ) : (
                  <>
                    Send Inquiry <FaArrowRight className="ml-2" />
                  </>
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
});

export default ContactForm;
